(() => {
  const init = () => {
    const home = document.querySelector('[data-spatial-home]');
    if (!home || home.dataset.spReady) return;
    home.dataset.spReady = 'true';
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const button = home.querySelector('[data-sp-motion]');
    let userPaused = false;
    try { userPaused = sessionStorage.getItem('spatial-paused') === 'true'; } catch {}
    const sync = () => {
      const paused = userPaused || media.matches;
      home.classList.toggle('sp-paused', paused);
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-pause-label]').hidden = paused;
      button.querySelector('[data-resume-label]').hidden = !paused;
      button.hidden = media.matches;
    };
    button.addEventListener('click', () => {
      userPaused = !userPaused;
      try { sessionStorage.setItem('spatial-paused', String(userPaused)); } catch {}
      sync();
    });
    media.addEventListener('change', sync);
    sync();
    if ('IntersectionObserver' in window && !media.matches) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('sp-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      home.querySelectorAll('[data-sp-reveal]').forEach(el => observer.observe(el));
      home.classList.add('sp-reveal-active');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
